<div class="bp-modal mod-lg">
  <bp-modal-header [cssStyle]="'mod-general'">
    <a right (click)="closeAll()" (keydown.enter)="closeAll()" [tabIndex]="0">{{ "abort" | translate }}</a>
  </bp-modal-header>
  <div class="bp-modal-body">
    <div class="bp-modal-body-section pl-45 pr-50 pt-0 pb-0">
      <div class="header">
        <ng-container *ngTemplateOutlet="header; context: { id: data.getId() }"></ng-container>
        <ng-template #header let-id="id">
          <img
            class="payment-ref-logo mt-15"
            [src]="id ? '/assets/images/edit_contact_header.svg' : '/assets/images/add_contact_header.svg'"
            [alt]="'contact_header_image_alt_text' | translate" />
          <div class="mt-15 font-size-17 stronger-text">
            {{
            (id ? "modal_contact_modal_header_edit_contact" : "modal_contact_header_new_contact")
            | translate
            }}
          </div>
          <div class="mt-10 mb-15 text-light">
            {{
            (id
            ? "modal_contact_modal_header_edit_contact_description"
            : "modal_contact_header_new_contact_description"
            ) | translate
            }}
          </div>
        </ng-template>
      </div>
      <div class="contact-modal-form-fields">
        <bp-input
          class="mod-ice-blue"
          [(model)]="data"
          field="_name"
          type="text"
          [maxlength]="40"
          [showCharCounter]="false"
          [label]="'modal_contact_name' | translate"
          [placeholder]="'label_for_contact_name' | translate"
          [error]="data.getValidationError('name') | translate"
        (onKeyEnter)="save()"></bp-input>
        @if (!!data.getId()) {
          <div class="justify-between">
            @if (inviteButtonText === 'invite_more_contacts') {
              <span class="text-green pr-20">
                <span class="bpi__icon-check"></span>
                {{ "taf_invite_sent" | translate }}
              </span>
            }
            @if (inviteButtonText !== 'invite_more_contacts') {
              <a (click)="sendTaf()" href="javascript:">
                <img
                  class="img-responsive mod-inline"
                  src="/assets/images/invite-friend.svg"
                  alt="{{ 'invite_now_image_alt' | translate }}" />
                {{ inviteButtonText | translate }}
              </a>
            }
            <a class="items-center" (click)="delete()" (keydown.enter)="delete()" [tabIndex]="0">
              <span class="bpi__icon-block font-size-18 mr-5 stronger-text"></span>
              {{ "modal_contact_remove_contact_field" | translate }}
            </a>
          </div>
        }
      </div>
    </div>
    <div class="bp-modal-body-section pl-45 pr-50 pb-10 pt-10 address-list">
      <div class="mb-20">
        <div class="container-left-right">
          <div class="flex-grow mr-0">
            <bp-input
              class="mod-ice-blue"
              [(model)]="data"
              field="_email"
              type="email"
              [label]="'email' | translate"
              [placeholder]="'enter_an_address' | translate"
              [error]="data?.getValidationError('email') | translate"
              (onKeyEnter)="save()">
            </bp-input>
          </div>
        </div>
        @if (data.getFields(false, false).length) {
          <hr class="mt-10 mb-10" />
        }
      </div>
      @for (field of data.getFields(false, false); track field; let i = $index; let last = $last) {
        <contact-address-select
          [contactField]="field"
          [validationError]="getValidationErrorForField(field)"
          (selectedIdEmitter)="updateSelectedIds()"
          [selectedIds]="selectedIds"
          (saveEmit)="save()"
        (deleteEmit)="deleteByObject(data.getFields(), field)"></contact-address-select>
        @if (!last) {
          <hr class="mt-30 mb-20" />
        }
      }
      @if (coinFilter().length !== 0) {
        <a
          class="mb-15 fit-content items-center"
          (click)="addNewAddress()"
          (keydown.enter)="addNewAddress()"
          [tabIndex]="0">
          <span class="bpi__icon-plus-circle mr-5"></span>
          {{ "modal_contact_add_additional_address" | translate }}
        </a>
      }
      <div class="justify-center confirm-button">
        <button class="btn btn-primary" (click)="save()">
          {{ (!data.getId() ? "save" : "save_changes") | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
